import React from 'react';
import PropTypes from 'prop-types';
import FormattedMessageWrappedInSpan from './FormattedMessageWrappedInSpan';

import { trackEvent } from '../../utils/ga-tracking';
import { Tooltip } from '@material-ui/core';
import OpenInNewRoundedIcon from '@material-ui/icons/OpenInNewRounded';
import { CopyToClipboardIcon, IconRoundedButton } from './Buttons';

const VoucherWithActions = ({ voucher }) => {
  const copyVoucherCodeGoToWeb = (voucherCode, linkUrl) => {
    navigator.clipboard.writeText(voucherCode).then(
      () => {
        window.open(linkUrl, '_blank', 'noreferrer');
      },
      (error) => {
        window.open(linkUrl, '_blank', 'noreferrer');
      }
    );
  };

  return (
    <div className="order-card-voucher">
      <a
        href={voucher?.campaign.url}
        onClick={() => trackEvent('Account', 'Voucher', 'Banner')}
        target="_blank"
      >
        <img src={voucher?.campaign.banner} />
      </a>
      <span className="order-card-voucher-actions">
        <FormattedMessageWrappedInSpan
          id="orderCard.voucherCode"
          defaultMessage="Voucher code: "
        />
        &nbsp;
        {voucher?.code}
        <span className="order-card-voucher-actions-buttons">
          <CopyToClipboardIcon stringToCopy={voucher?.code} />
          <Tooltip
            title={
              <FormattedMessageWrappedInSpan
                id="orderCard.voucherCopyAndGoMessage"
                defaultMessage="Copy and open website"
              />
            }
          >
            <IconRoundedButton
              icon={<OpenInNewRoundedIcon />}
              size={'small'}
              color={'blue'}
              onClick={() => copyVoucherCodeGoToWeb(voucher?.code, voucher?.campaign.url)}
            />
          </Tooltip>
        </span>
      </span>
    </div>
  );
};

VoucherWithActions.propTypes = {
  voucher: PropTypes.object,
};

export default VoucherWithActions;
